import React from 'react'

type BtnProps = {
    type: "button" | "submit" | "reset" | undefined,
    btn_text: string,
    onClick?: () => void,
    disable?: boolean
}

function Button({
    type,
    btn_text,
    onClick,
    disable
}: BtnProps) {
    return (
        <button className='button-style' disabled={disable} type={type} onClick={onClick}>{btn_text}</button>
    )
}

export default Button